import { TDeviceType } from '@cian/ui-kit';

import { getPlatformByDeviceType } from './getPlatformByDeviceType';
import { EHostType } from '../types/hostType';
import { ETelemetryEvents, TAppTelemetryLogger } from '../types/telemetry';

interface IGetTelemetryByPlatformParams {
  /** Телеметрия из thunk-контекста */
  telemetry: TAppTelemetryLogger;
  /** Реальный тип устройства */
  realDevice: TDeviceType;
  /** Тип хоста (page/frame) */
  hostType?: EHostType;
  /** Источник события (например, источник первого сообщения: offer, agent, customChat) */
  source?: string;
}

/**
 * @description
 * Возвращает обёртку над телеметрией, которая пишет события с ключом {platform}[.{hostType}].{event}[.{source}]
 */
export function getTelemetryByPlatform({ telemetry, realDevice, hostType, source }: IGetTelemetryByPlatformParams) {
  const platform = getPlatformByDeviceType(realDevice);

  const getTelemetryKey = (telemetryEvent: ETelemetryEvents) =>
    [platform, hostType, telemetryEvent, source].filter(Boolean).join('.');

  return {
    increment: (telemetryEvent: ETelemetryEvents) => {
      telemetry.increment(getTelemetryKey(telemetryEvent));
    },
    timing: (telemetryEvent: ETelemetryEvents, value: number) => {
      telemetry.timing(getTelemetryKey(telemetryEvent), value);
    },
  };
}
